import script from "./PhoneContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneContextMenu.vue?vue&type=style&index=0&id=ea302c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea302c3c"]])

export default __exports__